import { Bonus, BonusThresholdMetric } from '../bonus';
import { Money } from '../utils';

export enum ReferralCodeStatus {
  Active = 'ACTIVE',
  /** Once the sale is cancelled. */
  Deactivated = 'DEACTIVATED',
}

export interface Referral {
  progress: { metric: BonusThresholdMetric; current: number; target: number } | null;
  /** The friend's sale has reached the bonus threshold. */
  qualified: boolean;
  /** Stays null if this sale had ended before the friend qualified, so no Tipsbelöning was paid. */
  commissionPaidAt: string | null;
}

/** A sale's "Tipsa en kompis" code, shared by the whole group. */
export interface ReferralCode {
  code: string;
  status: ReferralCodeStatus;
  /** The sale's cutoff. */
  validUntil: string | null;
  useCount: number;
  /** null means unlimited. */
  maxUses: number | null;
  /** What the friend's sale gets. Always has a threshold. */
  bonus: Bonus;
  /** Tipsbelöning: what this sale earns per qualified friend. */
  commission: Money;
  /** Sales that used the code, oldest first, cancelled ones excluded. Anonymous on purpose. */
  referrals: Referral[];
}
